(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductTabs {
    constructor() {
      this.buttons = document.querySelectorAll('.tab-button');
      this.panels = document.querySelectorAll('.tab-panel');
      this.init();
    }

    init() {
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          this.switchTab(button.dataset.tab);
        });
      });
    }

    switchTab(tabName) {
      this.buttons.forEach((btn) => {
        btn.dataset.active = btn.dataset.tab === tabName ? 'true' : 'false';
      });
      this.panels.forEach((panel) => {
        panel.dataset.active = panel.dataset.tabContent === tabName ? 'true' : 'false';
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new ProductTabs();
    });
  } else {
    new ProductTabs();
  }

  } catch(e) { console.error(e); }
})();
})();
